<template>
  <b-row class="row sl-screen">
    <b-col lg="10" md="9" class="left-main-div-sl">
      <title-sl :title="title" :color="titlecolor" :type="pagetype" />
      <div>            
        <video class="videoPlayer" :lang="lang" v-if="!videoError" ref="videoPlayer" width="100%" controls controlslist="nodownload noremoteplayback noplaybackrate" preload="metadata" @error="handleVideoError" @enterpictureinpicture="handlePipEnter" @leavepictureinpicture="handlePipLeave" @play="handlePlay" @pause="handlePause" :key="videoKey" :poster="poster">
          <source :src="track" type="video/mp4" />
          <track v-if="trackSrcFr" :label="$t('generic.version-fr')" kind="subtitles" srclang="fr" :src="trackSrcFr" default>
          <track v-if="trackSrcEn" :label="$t('generic.version-en')" kind="subtitles" srclang="en" :src="trackSrcEn">
          <track v-if="trackSrcPl" :label="$t('generic.version-pl')" kind="subtitles" srclang="pl" :src="trackSrcPl">
          <track v-if="trackSrcEs" :label="$t('generic.version-de')" kind="subtitles" srclang="es" :src="trackSrcEs">        
        </video>

        <div class="play-icon" v-if="showPlayIcon" @click="toggleVideo" :style="{ top: topIcon + 'px' }">
          <!-- Icône de lecture (vous pouvez remplacer par votre propre icône) -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 1 22 22" fill="currentColor">
            <path d="M3 22v-20l18 10-18 10z"/>
          </svg>
        </div>  
        <div class="videoDescription">
          <span class="title">{{ title }}</span>
          <p>{{ description }}</p>
        </div>        
      </div>
    </b-col>

    <b-col lg="2" md="3" class="p-0">
      <div class="thumbnail-list sl-div-scroll pl-4 pr-4" ref="thumbnailColumn">
        <div v-for="(video, index) in playlist" :key="index" class="thumbnail-item">
          <div class="bg-thumbnail clickable" @click="playVideo(video)" @error="handleImageError(video)"></div>
          <img :src="video.sli_thumbnail?`${apiUrl}servicelines/thumbnail/${video.sli_thumbnail}?q=${token}&${(new Date()).getTime()}`:'img/theme/meet-up/poster.jpg'" alt="Thumbnail" @click="playVideo(video)" @error="handleImageError(video)">
          <div class="title">{{ video.servicelinelangs.find(x => x.lan_code == lang).sll_title }}</div>
          <div class="speakers">{{ video.sli_speakers }}</div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import Vue from 'vue';
  import { mapActions } from "vuex";
  import TitleSL from '@/components/ServiceLines/TitleSL';

  export default {
    name: 'sl-screen', 
    
    components: {
      'title-sl': TitleSL
    },
    props: {
      title: String,
      pagetype: String
    },
    mounted() {
      let q = this.$route.query;
      this.loadServiceLine(q.id);
    },    
    data() {
      return {
        lang: Vue.i18n.locale(),
        playlist: [],
        token: localStorage.getItem(Vue.Keys.TOKEN),
        apiUrl: process.env.VUE_APP_APIURL,
        trackSrcFr: null,
        trackSrcEn: null,
        track: null,
        poster: null,
        isPipActive: false,
        videoError: false,
        videoKey: 0,
        showPlayIcon: true,
        currentId: 0,
        topIcon: 0        
      };
    },
    computed:{
    },
    methods:{
      ...mapActions(["GetServiceLine", "GetListServiceLines"]),
      
      async loadServiceLine(id) {
        let token = localStorage.getItem(Vue.Keys.TOKEN);
        this.GetServiceLine(id)
          .then(
            async data => {
              console.log(data);
              this.trackSrcFr = data.servicelinelangs.find(x => x.lan_code == 'fr') != null?`data:text/vtt;base64,${data.servicelinelangs.find(x => x.lan_code == 'fr').vtt}` : null;
              this.trackSrcEn = data.servicelinelangs.find(x => x.lan_code == 'en') != null ? `data:text/vtt;base64,${data.servicelinelangs.find(x => x.lan_code == 'en').vtt}` : null;
              this.trackSrcPl = data.servicelinelangs.find(x => x.lan_code == 'pl') != null ? `data:text/vtt;base64,${data.servicelinelangs.find(x => x.lan_code == 'pl').vtt}` : null;
              this.trackSrcEs = data.servicelinelangs.find(x => x.lan_code == 'es') != null ? `data:text/vtt;base64,${data.servicelinelangs.find(x => x.lan_code == 'es').vtt}` : null;
              var d = new Date();
              this.track = `${this.apiUrl}${data.sli_streamlink}?q=${token}&${d.getTime()}`;
              this.poster = data.sli_thumbnail ? `${this.apiUrl}servicelines/thumbnail/${data.sli_thumbnail}?q=${token}&${(new Date()).getTime()}` : 'img/theme/meet-up/poster.jpg';
              this.title = data.servicelinelangs.find(x => x.lan_code == this.lang).sll_title;
              this.description = data.servicelinelangs.find(x => x.lan_code == this.lang).sll_description;
              this.pagetype = data.slt_id;
              this.videoKey++;
              this.currentId = data.sli_id;

              //Playlist
              let sLRequest= {
                lang: Vue.i18n.locale()
              };
              await this.GetListServiceLines(sLRequest);
              let all = this.$store.getters.AllServiceLines;
              this.playlist = all.filter(m => m.slt_id == data.slt_id && m.sli_id != this.currentId);
            }
        )
        .catch(
          error => console.log(error)
        )
      },
      checkVideoUrl(url) {
        return isVideoUrl(url);
      },
      handlePipEnter() {
        this.isPipActive = true;
      },
      handlePipLeave() {
        this.isPipActive = false;
      },
      handleVideoError() {
        this.videoError = true;
      },
      handleImageError(video) {
        video.thumbnailUrl = "img/theme/meet-up/poster.jpg";
      },
      playVideo(item) {
        this.track = `${this.apiUrl}${item.sli_streamlink}?q=${this.token}&${(new Date()).getTime()}`;
        this.poster = item.sli_thumbnail ? `${this.apiUrl}servicelines/thumbnail/${item.sli_thumbnail}?q=${this.token}&${(new Date()).getTime()}` : 'img/theme/meet-up/poster.jpg';
        this.title = item.servicelinelangs.find(x => x.lan_code == this.lang).sll_title;
        this.pagetype = item.slt_id;
        this.videoKey++;

        this.currentId = item.sli_id;
        let all = this.$store.getters.AllServiceLines;
        this.playlist = all.filter(m => m.slt_id == item.slt_id && m.sli_id != this.currentId);
      },
      handlePlay() {
        this.showPlayIcon = false;
      },
      handlePause() {
        this.showPlayIcon = true;
      },
      toggleVideo() {
        const videoElement = this.$refs.videoPlayer;
        if (videoElement.paused) {
          videoElement.play();
          this.showPlayIcon = false;
        } else {
          videoElement.pause();
          this.showPlayIcon = true;
        }
      },
      adjustPlayIconPos() {
        this.showPlayIcon = false;
        this.timeoutId = setTimeout(() => {
          const videoElement = this.$refs.videoPlayer;
          this.topIcon = (videoElement.offsetHeight - 0) / 2 + 75;

          this.showPlayIcon = true;
        }, 500);
      }               
    },
    watch: {
      track(newVal) {
        this.adjustPlayIconPos();
      },
      poster(newVal) {
        this.adjustPlayIconPos();
      }      
    }
  };
</script>